import { observer } from 'mobx-react-lite';
import React from 'react';
import type { ValueType } from 'react-select';

import type { IEventBilling } from '@feathr/blackbox';
import type { Billable, Event } from '@feathr/blackbox';
import { Button, Form } from '@feathr/components';
import BillableWidget from '@feathr/extender/components/BillableWidget';
import { StoresContext } from '@feathr/extender/state';

interface IProps {
  event: Event;
  onAdd: () => void;
  onNext: () => void;
  onPrevious: () => void;
}

function EventAddStepTwo({ event, onAdd, onNext, onPrevious }: IProps) {
  const { Billables } = React.useContext(StoresContext);
  const billing = event.get('billing');
  const billableId = billing && billing.billable_id ? billing.billable_id : null;
  const billable = billableId ? Billables.get(billableId) : undefined;

  function handleChange(value: ValueType<Billable>, refId?: string) {
    if (value instanceof Array) {
      return;
    }

    event.set({
      billing: {
        billable_id: (value as Billable).get('id'),
        reference_id: refId,
      } as IEventBilling,
    });
  }

  return (
    <Form
      actions={[
        <Button disabled={!billableId} key={'next'} onClick={onNext} type={'primary'}>
          Next
        </Button>,
        <Button key={'previous'} onClick={onPrevious} type={'naked'}>
          Previous
        </Button>,
      ]}
      description={
        <>
          <p>
            Choose a Billing Configuration for this Project.
            <br />
            You have two options to pay for media for Ad Campaigns in this Project:
          </p>
          <ul>
            <li style={{ listStyle: 'circle' }}>
              To <strong>pay as you go</strong>, choose or create a Billing Configuration{' '}
              <strong>with a Payment Method</strong> (credit card or ACH). Media spend incurred by
              Ad Campaigns in this Project will be charged to the Payment Method associated with the
              chosen Billing Configuration, if one is provided.
            </li>
            <li style={{ listStyle: 'circle' }}>
              To <strong>pre-pay for your media</strong>, you may choose or create a Billing
              Configuration <strong>without a Payment Method</strong>. You will be able to add Media
              Budget to the Project after you create it. You will be invoiced for the added media
              budget at the provided Bill To name and email address.
            </li>
          </ul>
        </>
      }
      label={'Create a Project: Billing configuration'}
    >
      <BillableWidget
        allowEdit={false}
        isLoading={event.isUpdating}
        onAdd={onAdd}
        onChange={handleChange}
        refId={billing ? billing.reference_id : undefined}
        value={billable}
      />
    </Form>
  );
}

export default observer(EventAddStepTwo);
